import { Divider, Grid, SxProps } from '@mui/material';
import React, { ReactElement } from 'react';
import FormItem from './FormItem';
import FormWidget from './FormWidget';
import { V } from '../Layout';
import { FORM_WIDGET_COMPONENTS } from './formConstants';

type FormContainerProps = {
    children: ReactElement | ReactElement[];
    titleI18nToken?: string;
    titleSx?: SxProps;
    hideTitle?: boolean;
    hidden?: boolean;
    containerSx?: SxProps;
    showDivider?: boolean;
};

export const FormContainer = ({
    children,
    titleI18nToken = undefined,
    titleSx = undefined,
    hideTitle = false,
    hidden = false,
    containerSx = undefined,
    showDivider = false
}: FormContainerProps) => {
    return (
        <V className="_formContainerWrapper" gap={0.5} hide={hidden}>
            {titleI18nToken && !hideTitle && (
                <FormItem sx={{ ...titleSx }}>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.sectionTitle}
                        i18nToken={titleI18nToken}
                        containerSx={{ textTransform: 'uppercase' }}
                    />
                </FormItem>
            )}
            <Grid className="_formContainer" container spacing={2} sx={{ width: '100%', ...containerSx }}>
                {children}
            </Grid>
            {showDivider && <Divider sx={{ mt: 2.5, width: '100%' }} />}
        </V>
    );
};
